import { Box, Typography } from "@mui/material";
import { Button } from "pepsico-ds";
const AddContent = ({ label, onClick }) => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "var(--Spacing-spacing-48, 48px)",
        padding:
          "var(--Spacing-spacing-8, 8px) var(--Spacing-spacing-0, 0px) var(--Spacing-spacing-8, 8px) 0px",
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "stretch",
      }}
    >
      <Typography
        noWrap
        sx={{
          overflow: "hidden",
          color: "var(--Tokens-Text-Primary, #3A3A3A)",
          fontFeatureSettings: "'liga' off, 'clig' off",
          textOverflow: "ellipsis",
          fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
          fontSize: "var(--Font-Size-H5, 24px)",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "var(--Line-Height-H5, 32px)",
        }}
      >
        {label}
      </Typography>
      <Button
        variant="tertiary"
        size="large"
        text="Add content"
        iconTrailing="note_add"
        onClick={onClick}
      />
    </Box>
  );
};

export default AddContent;
